import React, { Component, Fragment } from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import ReceivingPartNOSInputs from "./receivingPartNOSInputs";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { v4 as uuidv4 } from "uuid";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { initialDataDetail, tableDetailColumns } from "../config";
import Api from "../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {
  //   getCategoryType,
  getDataDetail,
  validateDataItem,
  fetchDataItem,
  constructGenSeqPayload,
} from "../utilUpdate";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";
import HotlineDetailDataInput from "../hotlineDetailDataInput";
import M from "moment";
import { checkNonQrCanUpdate } from "../service";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  forceGray: {
    backgroundColor: "#bfbaba !important",
    color: "#000000 !important",
    cursor: "not-allowed",
  },
};

class ReceivingPartNOSDetail extends Component {
  constructor(props) {
    super(props);
    this.listDataName = { QR: "partWithQR", NOQR: "partWithOutQR" };
    this.listTabPanel = ["QR", "NOQR"];
    this.handlers = {
      handleAddRow: this.handleAddRow,
      handleSaveRow: this.handleSaveRow,
      handleEditRow: this.handleEditRow,
      handleCancelRow: this.handleCancelRow,
      handleDeleteRow: this.handleDeleteRow,
      handleValueChange: this.handleValueChange,
      handleCategoryChange: this.handleCategoryChange,
      handleItemChange: this.handleItemChange,
      handleOrderTypeChange: this.handleOrderTypeChange,
      handleSingleLocatorChange: this.handleSingleLocatorChange,
      handleDetailHotlineVisible: this.handleDetailHotlineVisible,
    };
    this.state = {
      loading: false,
      warningModalVisible: false,
      activeTab: "QR",
      errorListCabang: undefined,
      errorGracePeriod: undefined,
      errorStartDate: undefined,
      errorEndDate: undefined,
      detailHotlineVisible: false,
      hasHotline: false,
      canEdit: false,
      validationErrors: {},
      tableColumn: [],
      dataTable: {
        QR: [],
        NOQR: [],
      },
      pagination: {
        page: 1,
        limit: 5,
        totalData: 0,
      },
      dataDetailSaved: [],
      selectedRow: null,
      dataCategory: [],
      dataItem: [],
      dataOrderType: [
        { value: "FIX", label: "Fix" },
        { value: "REGULER", label: "Reguler" },
        { value: "HOTLINE", label: "Hotline" },
        { value: "URGENT", label: "Urgent" },
      ],
    };
  }

  componentDidMount = async () => {
    try {
      this.handleTriggerLoading();

      await Promise.all([
        this.fetchDataLocator(),
        this.fetchDataSupplier(),
        this.fetchDataSupplierExpedition(),
      ]);

      Object.entries(this.listDataName).forEach(([key, value]) => {
        this.props.setValue(value, this.state.dataDetailSaved[key]);
      });

      if (R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)) {
        const id = await this.fetchGetNoSPBP();
        console.log(id);

        this.props.setValue("numberOfSPBP", id);
        this.props.setValue("dateOfSPBP", M(new Date()).format("DD-MM-YYYY"));
      }

      if (
        R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE) &&
        this.props.initialValues?.receivingPartId
      ) {
        await this.fetchDataDetail();
      }

      const tableColumn = {};
      const { classes } = this.props;
      for (const tab of this.listTabPanel) {
        tableColumn[tab] = tableDetailColumns.detail({
          handlers: this.handlers,
          state: this.state,
          listCategory: [],
          dataItem: this.state.dataItem,
          dataOrderType: this.state.dataOrderType,
          mode: this.props.mode,
          validationErrors: this.state.validationErrors || {},
          tableDetailColumns,
          classes,
        })[tab];
      }

      this.setState((prev) => ({
        ...prev,
        tableColumn,
        validationErrors: prev.validationErrors || {},
      }));
    } catch (error) {
      console.error("Error in componentDidMount:", error);
    } finally {
      this.handleTriggerLoading();
    }
  };

  componentDidUpdate = async (prevProps, prevState) => {
    const { activeTab, dataTable, dataItem, validationErrors } = this.state;

    if (prevState.dataTable !== dataTable) {
      Object.entries(this.listDataName).forEach(([key, value]) => {
        this.props.setValue(value, this.state.dataDetailSaved[key]);
      });
    }
    if (prevState.activeTab !== activeTab) {
      this.handleTriggerLoading();
      this.rebuildColumns();
      this.handleTriggerLoading();
    }

    if (prevState.dataItem !== dataItem) {
      this.rebuildColumns();
    }

    if (prevState.validationErrors !== validationErrors) {
      this.rebuildColumns();
    }

    if (prevState.hasHotline !== this.state.hasHotline) {
      this.rebuildColumns();
    }
  };

  rebuildColumns = () => {
    const { activeTab, dataItem, dataOrderType, validationErrors } = this.state;
    const { classes } = this.props;

    this.setState((prev) => ({
      tableColumn: {
        ...prev.tableColumn,
        [activeTab]: tableDetailColumns.detail({
          handlers: this.handlers,
          state: this.state,
          listCategory: [],
          dataItem,
          dataOrderType,
          mode: this.props.mode,
          validationErrors,
          classes,
        })[activeTab],
      },
    }));
  };

  handleWarningModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      warningModalVisible: !prevState.warningModalVisible,
    }));
  };

  handleSubmitModalVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      submitModalVisible: !prevState.submitModalVisible,
    }));
  };

  handleSaveRowModalVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      saveRowModalVisible: !prevState.saveRowModalVisible,
    }));
  };

  fetchDataLocator = async () => {
    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA",
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: this.props.selectedCabang?.value },
        page: null,
        limit: null,
      });

      if (res.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataLocator: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataSupplierExpedition = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.selectedCabang?.value,
        }),
      });
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataSupplierExpedition: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataSupplier = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getSupplierMainDealerBySourceCode,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.selectedCabang?.value,
        }),
      });

      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataSupplier: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleBeforeSubmit = () => {
    let valid = true;

    if (!this.props.validate()) {
      valid = false;
    }

    if (!valid) {
      this.handleWarningModalVisibility(
        "Terdapat field yang belum valid atau belum diisi dengan benar. Mohon periksa kembali.",
      );
      return;
    }

    const { dataTable } = this.state;
    this.props.setValue("partWithQR", dataTable.QR || []);
    this.props.setValue("partWithOutQR", dataTable.NOQR || []);

    const allData = [...(dataTable.QR || []), ...(dataTable.NOQR || [])];
    const hasIncomplete = allData.some((item) => item.saved === false);

    if (hasIncomplete || allData.length == 0) {
      this.handleWarningModalVisibility(
        "Terdapat data yang belum lengkap. Mohon periksa kembali.",
      );
      return;
    }

    // pengecekan qty (LOGIC LAMA TETAP)
    const originalQR = this.state.originalDataDetail?.QR || [];
    const updatedQR = dataTable.QR || [];

    const isQtyChanged = updatedQR.some((updated) => {
      const origin = originalQR.find((o) => o.id === updated.id);
      if (!origin) return false;

      const originalQty = parseInt(origin.quantity || 0);
      const updatedQty = parseInt(updated.quantity || 0);

      return originalQty !== updatedQty;
    });

    if (isQtyChanged) {
      this.handleSaveRowModalVisibility();
      return;
    }

    this.handleSubmitModalVisibility();
  };

  handleSubmit = () => {
    if (this.props.onSubmit) {
      this.props.onSubmit(this.props.controls);
    }
  };

  handleAddRow = async () => {
    const { activeTab } = this.state;

    const newData = {
      id: uuidv4(),
      ...initialDataDetail,
      isNew: true,
    };

    this.setState(
      (prevState) => ({
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [activeTab]: [...prevState.dataTable[activeTab], newData],
        },
      }),
      async () => {
        const lastIndex = this.state.dataTable[activeTab].length - 1;
        await this.fetchDataItem(lastIndex);
      },
    );
  };

  handleSaveRow = async (index) => {
    const activeTab = this.state.activeTab;
    const rowData = this.state.dataTable[activeTab][index];

    const errors = validateDataItem(rowData, this.state.hasHotline);
    if (!R.isEmpty(errors)) {
      this.setState((prev) => ({
        validationErrors: {
          ...prev.validationErrors,
          [activeTab]: {
            ...(prev.validationErrors?.[activeTab] || {}),
            [index]: errors,
          },
        },
      }));
      return;
    }

    const prev = this.state;
    const newData = [...prev.dataTable[activeTab]];
    const originalData = prev.originalDataDetail?.[activeTab] || [];

    const originalRow = originalData.find(
      (r) =>
        r.partCode?.value === rowData.partCode?.value &&
        r.purchaseOrderNo === rowData.purchaseOrderNo &&
        r.locatorId?.value === rowData.locatorId?.value,
    );

    const isViolation =
      !rowData.isNew &&
      !!originalRow &&
      originalRow.orderType?.value !== rowData.orderType?.value;

    console.log({
      index,
      partCode: rowData.partCode?.value,
      isNew: !!rowData.isNew,
      foundOriginal: !!originalRow,
      originalOrderType: originalRow?.orderType?.value,
      currentOrderType: rowData.orderType?.value,
      isViolation,
    });

    const isDuplicate = prev.dataTable[activeTab].some(
      (item, i) =>
        i !== index &&
        item.partCode?.value === rowData.partCode?.value &&
        item.locatorId?.value === rowData.locatorId?.value,
    );

    if (isDuplicate) {
      this.handleWarningModalVisibility(
        "Data part sudah terdapat pada list. Mohon periksa kembali.",
      );
      return;
    }

    if (originalRow && originalRow.canEdit === false) {
      this.handleWarningModalVisibility(
        "Perubahan ditolak karena sudah ada part dengan QR yang sudah ditransaksikan.",
      );
      this.rollbackTable(activeTab);
      return;
    }

    if (originalRow && !originalRow.barcode) {
      const apiResult = await checkNonQrCanUpdate({
        kodeCabang: this.props.selectedCabang?.value,
        kodeLocator: originalRow.locatorId?.value,
        kodePart: originalRow.partCode?.value,
        receivingNumberId: this.props.initialValues?.numberOfSPBP,
        qty: originalRow.quantity,
        changesQty: Number(rowData.quantity ?? rowData.qty ?? 0),
        setError: this.props.setError,
      });

      if (apiResult?.data?.data !== true) {
        this.handleWarningModalVisibility(
          "Perubahan ditolak karena sudah ada part dengan QR yang sudah ditransaksikan.",
        );
        this.rollbackTable(activeTab);
        return;
      }
    }

    const updatedRow = { ...newData[index], saved: true, isViolation };
    newData[index] = updatedRow;

    const updatedTable = newData.map((item) => {
      if (item.isNew) return { ...item, isViolation: false };
      const origin = originalData.find(
        (r) =>
          r.partCode?.value === item.partCode?.value &&
          r.purchaseOrderNo === item.purchaseOrderNo &&
          r.locatorId?.value === item.locatorId?.value,
      );
      const rowViolation =
        !!origin && origin.orderType?.value !== item.orderType?.value;
      return { ...item, isViolation: rowViolation };
    });

    if (this.props.onViolationChange) {
      this.props.onViolationChange(updatedTable.some((r) => r.isViolation));
    }

    this.setState((prev2) => ({
      ...prev2,
      dataTable: {
        ...prev2.dataTable,
        [activeTab]: updatedTable,
      },
      dataDetailSaved: {
        ...prev2.dataDetailSaved,
        [activeTab]: updatedTable,
      },
      validationErrors: {
        ...prev2.validationErrors,
        [activeTab]: {
          ...(prev2.validationErrors?.[activeTab] || {}),
          [index]: undefined,
        },
      },
    }));
  };

  rollbackTable = (activeTab) => {
    const original = this.state.originalDataDetail?.[activeTab] || [];

    const rolledBack = original.map((item) => ({
      ...item,
      saved: true,
      isViolation: false,
    }));

    this.setState((prev) => ({
      ...prev,
      dataTable: {
        ...prev.dataTable,
        [activeTab]: rolledBack,
      },
      dataDetailSaved: {
        ...prev.dataDetailSaved,
        [activeTab]: rolledBack,
      },
    }));
  };

  // handleSaveRow = (index) => {
  //   const activeTab = this.state.activeTab;
  //   const rowData = this.state.dataTable[activeTab][index];

  //   const errors = validateDataItem(rowData, this.state.hasHotline);
  //   if (!R.isEmpty(errors)) {
  //     this.setState((prev) => ({
  //       validationErrors: {
  //         ...prev.validationErrors,
  //         [activeTab]: {
  //           ...(prev.validationErrors?.[activeTab] || {}),
  //           [index]: errors,
  //         },
  //       },
  //     }));
  //     return;
  //   }

  //   this.setState((prev) => {
  //     const newData = [...prev.dataTable[activeTab]];
  //     const originalData = prev.originalDataDetail?.[activeTab] || [];

  //     const originalRow = originalData.find(
  //       (r) =>
  //         r.partCode?.value === rowData.partCode?.value &&
  //         r.purchaseOrderNo === rowData.purchaseOrderNo &&
  //         r.locatorId?.value === rowData.locatorId?.value
  //     );

  //     const isViolation =
  //       !rowData.isNew &&
  //       !!originalRow &&
  //       originalRow.orderType?.value !== rowData.orderType?.value;
  //     console.log(originalRow);

  //     console.log({
  //       index,
  //       partCode: rowData.partCode?.value,
  //       isNew: !!rowData.isNew,
  //       foundOriginal: !!originalRow,
  //       originalOrderType: originalRow?.orderType?.value,
  //       currentOrderType: rowData.orderType?.value,
  //       isViolation,
  //     });

  //     const isDuplicate = prev.dataTable[activeTab].some(
  //       (item, i) =>
  //         i !== index &&
  //         item.partCode?.value === rowData.partCode?.value &&
  //         item.locatorId?.value === rowData.locatorId?.value
  //     );

  //     if (isDuplicate) {
  //       this.handleWarningModalVisibility(
  //         "Data part sudah terdapat pada list. Mohon periksa kembali."
  //       );
  //       return prev;
  //     }

  //     if (originalRow && originalRow.canEdit === false) {
  //       this.handleWarningModalVisibility("Perubahan ditolak karena sudah ada part dengan QR yang sudah ditransaksikan.");
  //       return prev;
  //     }

  //     const updatedRow = {
  //       ...newData[index],
  //       saved: true,
  //       isViolation,
  //     };
  //     newData[index] = updatedRow;

  //     const updatedTable = newData.map((item) => {
  //       if (item.isNew) return { ...item, isViolation: false };
  //       const origin = originalData.find(
  //         (r) =>
  //           r.partCode?.value === item.partCode?.value &&
  //           r.purchaseOrderNo === item.purchaseOrderNo &&
  //           r.locatorId?.value === item.locatorId?.value
  //       );
  //       const rowViolation =
  //         !!origin && origin.orderType?.value !== item.orderType?.value;
  //       return { ...item, isViolation: rowViolation };
  //     });

  //     if (this.props.onViolationChange) {
  //       const anyViolation = updatedTable.some((r) => r.isViolation);
  //       this.props.onViolationChange(anyViolation);
  //     }

  //     return {
  //       ...prev,
  //       dataTable: {
  //         ...prev.dataTable,
  //         [activeTab]: updatedTable,
  //       },
  //       dataDetailSaved: {
  //         ...prev.dataDetailSaved,
  //         [activeTab]: updatedTable,
  //       },
  //       validationErrors: {
  //         ...prev.validationErrors,
  //         [activeTab]: {
  //           ...(prev.validationErrors?.[activeTab] || {}),
  //           [index]: undefined,
  //         },
  //       },
  //     };
  //   });
  // };

  handleEditRow = async (index) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];

      const savedPrevValue = newState[index];
      newState[index] = {
        ...newState[index],
        saved: !newState[index].saved,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
        selectedRow: {
          ...prevState.selectedRow,
          [this.state.activeTab]: {
            ...prevState.selectedRow?.[this.state.activeTab],
            [index]: savedPrevValue,
          },
        },
      };
    });

    const categoryId =
      this.state.dataTable[this.state.activeTab][index].category?.value;
    await this.fetchDataItem(index, categoryId);
  };

  handleCancelRow = (index) => {
    this.setState((prevState) => {
      let dataTable = prevState.dataTable[this.state.activeTab];
      if (
        R.isNil(prevState.selectedRow) ||
        R.isEmpty(prevState.selectedRow) ||
        R.isEmpty(prevState.selectedRow?.[this.state.activeTab])
      ) {
        dataTable = [
          ...prevState.dataTable[this.state.activeTab].filter(
            (_, idx) => idx !== index,
          ),
        ];
      } else {
        dataTable[index] = Object.values(
          prevState.selectedRow[this.state.activeTab],
        ).find((item) => item.id === dataTable[index].id);
      }

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: dataTable,
        },
        selectedRow:
          !R.isNil(prevState.selectedRow) && !R.isEmpty(prevState.selectedRow)
            ? {
                ...prevState.selectedRow,
                [this.state.activeTab]: Object.values(
                  prevState.selectedRow[this.state.activeTab],
                ).filter((item) => item.id !== dataTable[index].id),
              }
            : null,
      };
    });
  };

  handleDeleteRow = (index) => {
    const active = this.state.activeTab;

    this.setState((prevState) => {
      const tableList = prevState.dataTable?.[active] || [];
      const savedList = prevState.dataDetailSaved?.[active] || [];
      const selectedRow = tableList[index];

      if (selectedRow && selectedRow.canEdit === false) {
        this.handleWarningModalVisibility(
          "Data tidak dapat dihapus, karena terdapat part yang sudah di transaksikan!",
        );
        return null;
      }

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [active]: tableList.filter((_, idx) => idx !== index),
        },
        dataDetailSaved: {
          ...prevState.dataDetailSaved,
          [active]: savedList.filter((_, idx) => idx !== index),
        },
      };
    });
  };

  handleValueChange = (index, name, value) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];
      newState[index] = {
        ...newState[index],
        [name]: value,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
      };
    });
  };

  handleCategoryChange = async (index, name, value) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];
      newState[index] = {
        ...newState[index],
        [name]: value,
        name: null,
        kode: null,
        satuan: null,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
      };
    });

    this.handleTriggerLoading();
    await this.fetchDataItem(index, value.value);
    this.handleTriggerLoading();
  };

  handleDetailHotlineVisible = () => {
    console.log("cek");

    this.setState((prevState) => ({
      ...prevState,
      detailHotlineVisible: !prevState.detailHotlineVisible,
    }));
  };

  handleSelectHotline = (value) => {
    const { tab } = this.props;
    this.setValueObject(tab, value);
    this.handleDetailHotlineVisible();
  };

  setValueObject = (tab, value) => {
    this.props.onSetState((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        [tab]: {
          ...prevState.data[tab],
          ...value,
        },
      },
    }));
  };

  handleItemChange = (index, name, value) => {
    const activeTab = this.state.activeTab;

    if (!value) {
      this.setState((prev) => {
        const newData = [...prev.dataTable[activeTab]];
        const updatedRow = { ...newData[index] };

        updatedRow.partCode = null;
        updatedRow.partName = null;
        updatedRow.categoryName = "";
        updatedRow.satuan = "";
        updatedRow.kode = "";
        updatedRow.saved = false;

        newData[index] = updatedRow;

        return {
          ...prev,
          dataTable: {
            ...prev.dataTable,
            [activeTab]: newData,
          },
        };
      });
      return;
    }

    this.setState((prevState) => {
      const newData = [...prevState.dataTable[activeTab]];
      const selectedPart = value;
      const updatedRow = { ...newData[index] };

      if (name === "partCode") {
        updatedRow.partCode = {
          label: selectedPart.value,
          value: selectedPart.value,
        };
        updatedRow.partName = {
          label: selectedPart.partName,
          value: selectedPart.partName,
        };
      } else if (name === "partName") {
        updatedRow.partName = {
          label: selectedPart.label,
          value: selectedPart.value,
        };
        updatedRow.partCode = {
          label: selectedPart.value,
          value: selectedPart.value,
        };
      }

      updatedRow.kode = selectedPart?.value || "";
      updatedRow.satuan = selectedPart?.satuan || "";
      updatedRow.categoryName = selectedPart?.partCategory || "";
      updatedRow.saved = false;

      newData[index] = updatedRow;

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [activeTab]: newData,
        },
      };
    });
  };

  handleOrderTypeChange = (rowIndex, value) => {
    this.setState((prev) => {
      const activeTab = prev.activeTab;
      const updatedTable = [...prev.dataTable[activeTab]];
      updatedTable[rowIndex] = {
        ...updatedTable[rowIndex],
        orderType: value,
      };

      const hasHotline = updatedTable.some(
        (r) => r?.orderType?.value === "HOTLINE" || r?.orderType === "HOTLINE",
      );

      return {
        ...prev,
        dataTable: {
          ...prev.dataTable,
          [activeTab]: updatedTable,
        },
        hasHotline,
      };
    });
  };

  handleSingleLocatorChange = (index, value) => {
    this.setState((prevState) => {
      const activeTab = prevState.activeTab;
      const newData = [...prevState.dataTable[activeTab]];

      newData[index] = {
        ...newData[index],
        locatorId: value,
        saved: false,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [activeTab]: newData,
        },
      };
    });
  };

  handleTabChange = (index) => {
    const tabName = this.listTabPanel[index];

    this.setState((prev) => ({
      ...prev,
      activeTab: tabName,
      pagination: {
        ...prev.pagination,
        page: 1,
        limit: 5,
      },
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchGetNoSPBP = async () => {
    let payload = constructGenSeqPayload(this.props.selectedCabang?.value);
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave(
        payload,
      );
      return res.ok ? res.data : null;
    } catch (error) {
      console.log("error: ", error);
    }
  };

  fetchDataDetail = async () => {
    const id = this.props.initialValues.receivingPartId;

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getReceivingPartNOSById,
      menuName: "Master Receiving Part H2",
      setError: this.props.setError,
      args: contructQueryParam({ receivingPartId: id }),
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data?.data;

      this.props.setValue("id", data?.id);
      this.props.setValue("receivingPartId", data?.receivingPartId);
      this.props.setValue("numberOfSPBP", data?.numberOfSPBP);
      this.props.setValue("invoiceNo", data?.invoiceNo);
      this.props.setValue("receivedNo", data?.receivedNo);
      this.props.setValue("note", data?.note);
      this.props.setValue("carId", data?.carId);

      const supplier = data?.supplier;
      this.props.setValue(
        "supplierId",
        supplier
          ? {
              value: supplier.supplierCode,
              label: supplier.supplierName,
              name: supplier.supplierName,
            }
          : null,
      );

      const supplierExp = data?.expedition;
      this.props.setValue(
        "expeditionId",
        supplierExp
          ? {
              value: supplierExp.supplierCode,
              label: supplierExp.supplierName,
              name: supplierExp.supplierName,
            }
          : null,
      );

      const dataQR = getDataDetail("QR", data.partWithQR);
      const dataNOQR = getDataDetail("NOQR", data.partWithOutQR);

      const originalQR = JSON.parse(JSON.stringify(dataQR));
      const originalNOQR = JSON.parse(JSON.stringify(dataNOQR));

      this.setState((prevState) => ({
        ...prevState,
        canEdit: dataQR.dataQR,
        dataTable: {
          ...prevState.dataTable,
          QR: dataQR,
          NOQR: dataNOQR,
        },
        dataDetailSaved: {
          ...prevState.dataDetailSaved,
          QR: dataQR,
          NOQR: dataNOQR,
        },
        originalDataDetail: {
          QR: originalQR,
          NOQR: originalNOQR,
        },
      }));
    }
  };

  fetchDataCategory = async (body) => {
    try {
      const res = await Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam(
        body,
      );
      if (res.ok) {
        return res.data.data;
      }
    } catch (error) {
      console.log("errors: ", error);
    }

    return null;
  };

  fetchDataItem = async (index, categoryId) => {
    try {
      const res = await fetchDataItem(this.state.activeTab, categoryId);
      const data = Array.isArray(res) ? res : [];

      this.setState((prevState) => {
        const { activeTab } = prevState;

        return {
          dataItem: {
            ...prevState.dataItem,
            [activeTab]: {
              ...(prevState.dataItem?.[activeTab] || {}),
              [index]: data,
            },
          },
        };
      });

      return data;
    } catch (error) {
      console.error("Error fetching data item:", error);
      return [];
    }
  };

  handleClear = () => {
    const { controls } = this.props;

    Object.keys(controls).forEach((key) => {
      if (key === "numberOfSPBP" || key === "dateOfSPBP") {
        return;
      }

      if (key === "partWithQR" || key === "partWithOutQR") {
        this.props.setValue(key, []);
      } else if (key === "supplierId" || key === "expeditionId") {
        this.props.setValue(key, null);
      } else if (key === "shippingDate") {
        this.props.setValue(key, null);
      } else {
        this.props.setValue(key, "");
      }
    });

    const clearedDataTable = {
      QR: [],
      NOQR: [],
    };

    // const clearedDataTable = this.listTabPanel.reduce((acc, tab) => {
    //   acc[tab] = [];
    //   return acc;
    // }, {});

    this.setState({
      dataTable: clearedDataTable,
    });
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const {pagination} = this.state;
    return (
      <>
        <SimpleModal
          title="Detail Penerimaan Part - NOS"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <ReceivingPartNOSInputs
                {...this.props}
                activityRead={this.state.activityRead}
                dataSupplier={this.state.dataSupplier}
                dataSupplierExpedition={this.state.dataSupplierExpedition}
              />

              {this.props.mode != "view" && (
                <FlexView vAlignContent="center" className="margin-bottom-10px">
                  <SimpleButton
                    className={"btn btn-plus background-red margin-left-none"}
                    onClick={this.handleAddRow}
                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                    text={"Tambah"}
                  />
                </FlexView>
              )}

              <Tabs onSelect={this.handleTabChange}>
                <TabList>
                  {this.listTabPanel.map((tab, index) => (
                    <Tab key={index}>
                      {R.equals(tab, "QR") ? "Dengan QR" : "Tanpa QR"}
                    </Tab>
                  ))}
                </TabList>

                {this.listTabPanel.map((tab, index) => (
                  <TabPanel key={tab}>
                    <SimpleDataTable
                      key={`${pagination.totalData}-${pagination.page}`}
                      data={this.state.dataTable[tab]}
                      columns={this.state.tableColumn[tab] || []}
                      toCount={this.state.dataTable[tab].length}
                      rowsPerPage={pagination.limit}
                      page={pagination.page - 1}
                      options={{
                        ...defaultTableChange(
                          this.handleChangePage,
                          this.handleRowsPerPage,
                        ),
                        serverSide: false,
                      }}
                      // rowsPerPage={this.state.dataTable[tab].length}
                      // page={0}
                      // options={{ ...defaultTableChange() }}
                    />
                  </TabPanel>
                ))}
              </Tabs>

              {this.props.mode != "view" && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ textAlign: "right", marginTop: "10px" }}>
                    <SimpleButton
                      text="Clear"
                      type="button"
                      onClick={() => this.handleClear()}
                    />
                  </div>
                  <div style={{ textAlign: "right", marginTop: "10px" }}>
                    <SimpleButton
                      text="Simpan"
                      type="button"
                      onClick={() => this.handleBeforeSubmit()}
                    />
                  </div>
                </div>
              )}
            </ModalContainer>
          }
        />

        {this.state.warningModalVisible && (
          <SimpleAlert
            title={
              this.state.warningType === "warning"
                ? "Peringatan"
                : "Information"
            }
            content={
              <div>
                <p>{this.state.warningMessage}</p>
              </div>
            }
            additionalButtons={
              <Fragment>
                <FlexView>
                  <SimpleButton
                    text="OK"
                    secondary
                    onClick={() => this.handleWarningModalVisibility()}
                  />
                </FlexView>
              </Fragment>
            }
            visible={this.state.warningModalVisible}
            onClickClose={this.handleWarningModalVisibility}
          />
        )}

        {this.state.submitModalVisible && (
          <SimpleAlert
            title={"Confirmation"}
            content={"Apakah anda yakin ingin menyimpan data ini?"}
            visible={this.state.submitModalVisible}
            onClickClose={this.handleSubmitModalVisibility}
            onSubmit={this.submitModalVisible}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Batal"
                  onClick={() => this.handleSubmitModalVisibility()}
                />
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  disabled={this.props.isSubmitting}
                  text="Iya"
                  onClick={() => this.handleSubmit()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.saveRowModalVisible && (
          <SimpleAlert
            title="Konfirmasi"
            content="Perubahan jumlah/Qty akan menggenerate QR Code baru, apakah anda yakin merubah nilai jumlah/Qty pada tabel ini?"
            visible={this.state.saveRowModalVisible}
            onClickClose={() => this.handleSaveRowModalVisibility(false)}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  type="button"
                  text="Batal"
                  onClick={() => this.handleSaveRowModalVisibility()}
                />
                <SimpleButton
                  type="button"
                  text="Iya"
                  onClick={() => this.handleSubmit()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.detailHotlineVisible && (
          <HotlineDetailDataInput
            // {...this.props}
            visible={this.state.detailHotlineVisible}
            title="Cari No. Hotline"
            onSelect={this.handleSelectHotline}
            onClickClose={this.handleDetailHotlineVisible}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

export default withFormGroup(withStyles(styles)(ReceivingPartNOSDetail));
